import 'css-chunksrc/client/scenes/comments/feed/styles.scss';export default {
  "feed": "_feed_3qddx_1",
  "comment": "_comment_3qddx_8",
  "ownComment": "_ownComment_3qddx_15",
  "replyInput": "_replyInput_3qddx_19"
};